import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { CartService } from '../services/cart.service';
import { UtilitiesService } from '../utilities/utilities.service';

@Component({
  selector: 'app-sample-purchase',
  templateUrl: './sample-purchase.component.html',
  styleUrls: ['./sample-purchase.component.scss']
})
export class SamplePurchaseComponent implements OnInit {

  constructor(private CS: CartService,
    private UTS: UtilitiesService,
    private router: Router) { }

  ngOnInit(): void {
  }

  addToShoppingCartOneByOne() {
    const payload = {"skuId":"bgSku3820204496","productId":"prod1260310","quantity":1,"landingFrom":"TopBrands_Apple","addons":[],"selectedPaymentOptionId":"-1","isExistingAccountNumber":false,"accountNumberSelected":null};
    
    this.CS.addToShoppingCartOneByOne(payload).subscribe((r: any) => {
      if (r) {
        this.router.navigate(['/cart']);
      }
    }, (e) => {
      this.UTS.error(e);
    })
  }
}
